export default "__VITE_ASSET__pPO6AepK__"